import { observer } from 'mobx-react';
import { FC, ReactElement } from 'react';
import { DashboardCrumbs } from '../../constants/dashboard';
import { dashboardStore } from '../../store/dashboardStore';
import DashboardDetailsChannelsCrumb from '../DashboardDetailsChannelsCrumb/DashboardDetailsChannelsCrumb';
import './style.scss';

const DashboardDetailsCrumbs: FC = observer((): ReactElement => {
  const renderCrumb = (): ReactElement | null => {
    switch (dashboardStore.selectedCrumb) {
      case DashboardCrumbs.BRANCHES:
        // Dashboard step 2
        return null;
      case DashboardCrumbs.ZONES:
        // Dashboard step 2
        return null;
      case DashboardCrumbs.CHANNELS:
        return <DashboardDetailsChannelsCrumb />;
      default:
        return null;
    }
  };

  return <div className="dashboard-details-crumbs">{renderCrumb()}</div>;
});

export default DashboardDetailsCrumbs;
